const BRAND_BLACK = '#0A171F';
const SHARE_BUTTON_WHITE = '#FFFFFF';
export const LIFE_EVENT_TEXT = '#FAFAFA';
export const LIFE_EVENT_BACKGROUND = '#F2F6F8';
export const CONTENTS_CARD_BACKGROUND = '#ADADAD';

export const REBRANDING_THEME = {
  light: {
    /** Mobile: black */
    'share-btn-foreground': BRAND_BLACK,
    /** PC: text white */
    'share-btn-foreground-inverse': SHARE_BUTTON_WHITE,
    /** PC: background black */
    'share-btn-background': BRAND_BLACK,
    'contents-card-background': CONTENTS_CARD_BACKGROUND,
    'contents-title': BRAND_BLACK,
  },
  dark: {
    /** Mobile: white */
    'share-btn-foreground': SHARE_BUTTON_WHITE,
    /** PC: text white */
    'share-btn-foreground-inverse': BRAND_BLACK,
    /** PC: 버튼 배경색 검정 */
    'share-btn-background': SHARE_BUTTON_WHITE,
    'contents-card-background': CONTENTS_CARD_BACKGROUND,
    'contents-title': SHARE_BUTTON_WHITE,
  },
} as const;
